import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

export const PageContainer = styled.div`
  padding-block-start: 16px;

  ${theme.breakpoints.up("tablet")} {
    padding-block-start: 24px;
  }
`;

export const PageContent = styled.div`
  max-inline-size: 1032px;
  margin-inline: auto;
`;

export const MainHeading = styled.h1`
  margin-block-end: 20px;

  color: #001246;
  font-weight: 700;
  font-size: 32px;
  font-family: ${fontRobotoCondensed};
  line-height: 38px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 16px;

    font-weight: 700;
    font-size: 60px;
    font-family: ${fontRobotoCondensed};
    line-height: 57px;
  }
`;

export const SubHeading = styled.h3`
  margin-block-end: 16px;

  color: #001246;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 16px;
  text-transform: uppercase;
`;
